<template>
    <!-- 对账记录 -->
    <div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="submitForm">
				<el-form-item>
				    <el-input
				        size
				        clearable
				        v-model="submitForm.memberNo"
				        placeholder="商户编号"
				    ></el-input>
				</el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
				<el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(submitForm)"
                    >查询</el-button>
                </el-form-item>
<!-- 				<el-form-item>
				  <el-button
				      size="small"
				      type="primary"
				      icon="el-icon-download"
				      :loading="downLoading"
				      @click="handleDownLoad(submitForm)"
				  >导出数据</el-button>
				</el-form-item> -->
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="centerList" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="type"
				    label="分类"
					width="80"

				>
					 <template slot-scope="scope">
						 <span v-if="scope.row.type == 'RetreatOrderData'">风控退单</span>
						 <span style="color: blue;" v-if="scope.row.type == 'CaseData'">风控案例</span>
						 <span style="color: red;" v-if="scope.row.type == 'DispatchOrderData'">风控调单</span>
					 </template>
				</el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="case_no"
					width="180"
                    label="编号"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_no"
                    label="商户号"
					width="160"
                ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="risk_class_name"
				    label="风险类别名称"
				    width="120"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="system_treatment_measures"
				    label="系统处理措施"
            width="120"
				>
					<template slot-scope="scope">
					   <div :content="scope.row.system_treatment_measures" placement="top">
						 <p class="descStyle">{{ scope.row.system_treatment_measures }}</p>
					   </div>
					 </template>
				</el-table-column>
 				<el-table-column
				    header-align="center"
				    align="center"
				    prop="case_qualification_desc"
				    label="案例所需资质说明"
            width="240"
				></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="failReason"
            label="失败原因"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="failDetail"
            label="失败详情"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="remark"
            label="备注"
        ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="case_deal_way"
				    label="处理方式"
				    width="90"
					:formatter="format_deal_way"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="audit_status"
				    label="流程状态"
				    width="90"
					:formatter="format_audit_status"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="deal_time"
					width="160"
				    label="发送时间"
				></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    width="100"
                >
                     <template slot-scope="scope" >
						<el-button @click="handleInfo(scope.row.merchant_no,scope.row.case_no,scope.row.type)" type="text" size="normal" v-if="scope.row.audit_status != 'SHTG' && scope.row.is_update == 1">处理</el-button>
						<el-button type="text" size="normal" v-if="scope.row.is_update == 2">已处理</el-button>
                     </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <!-- <record-info v-if="info.isShow" :info="info" @infoClose="handleCloseInfo"></record-info> -->
    </div>
</template>

<script>
import riskClassDetail from './riskClassDetail';
import riskClassOrderDetail from './riskClassOrderDetail';

export default {
    data() {
        return {
			submitForm: {
			    memberNo: '', //商户号
				createDateBegin: "",
				createDateEnd: "",
				page: 1,
				limit: 10
			},
            rangeDate: [], //时间范围
            centerList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false,
			downLoading: false, //导出loading
        }
    },
    components: {
		riskClassDetail,riskClassOrderDetail
    },
    mounted() {
		this.handleDefaultTime();
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
        handleSearch(submitForm) { //搜索
            this.currentPage = 1;
            submitForm.page = 1;
            this.getData(submitForm);
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.submitForm.page = page;
            this.submitForm.limit = this.pageSize;
            this.getData(this.submitForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.submitForm.page = 1;
            this.submitForm.limit = limit;
            this.getData(this.submitForm);
        },
        getData() { //获取数据
            this.$api.post("export/risk_class_list", this.submitForm, res => {
                if (res.code == "00") {
                    // let data = res.data;
                    this.total =  res.data.count; //总数
                    this.centerList = res.data.list;
                    // this.centerList = [];
                    //渲染结束后取消加载
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
		handleDownLoad() { //导出
		  this.downLoading = true;
		  this.$api.post("export/risk_class_list_download", this.submitForm, res => {
		    if (res.code == 0) {
		      this.$message.success(res.msg);
		      var link=this.$file_url+res.data;
		      window.open(link)
		    } else {
		      this.$message.error(res.msg);
		    }
		    //渲染结束后取消加载
		    this.downLoading = false;
		  })
		},
		handleInfo(merchant_no,case_no,type){
			if(type=="CaseData"){
				this.$router.push({ path: '/riskClassDetail', query: {mercNum:merchant_no,caseNo:case_no}});
			}
			if(type=="DispatchOrderData"){
				// this.$message.error("暂未开放");
				this.$router.push({ path: '/riskClassOrderDetail', query: {caseNo:case_no}});
			}
		},
		handleDefaultTime() { //默认获取三十天
		    let date =this.$moment().endOf('day').format('x');
		    this.submitForm.createDateEnd = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
		    this.submitForm.createDateBegin = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD HH:mm:ss");
		    this.rangeDate = [this.submitForm.createDateBegin, this.submitForm.createDateEnd];
		},
        pickerChange(DateArr) { //时间选择器
            this.submitForm.createDateBegin = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.submitForm.createDateEnd = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
		format_deal_way(row) {
		    let card = ''; //1.借记卡 2.贷记卡
		    switch (row.case_deal_way) {
				case  "investigate":
					card = '风控调查';
					break;
				case  "warn":
					card = '预警';
					break;
		        default:
		            card = '/';
		            break;
		    }
		    return card;
		},
		format_audit_status(row) {
		    let card = ''; //1.借记卡 2.贷记卡
		    switch (row.audit_status) {
				
				case  "DDSH":
					card = '待审核';
					break;
				case  "SHZ":
					card = '审核中';
					break;
				case  "TH":
					card = '回退';
					break;
				case  "SHTG":
					card = '审核通过';
					break;
				case  "THCH":
					card = '退回初审';
					break;
		        default:
		            card = '/';
		            break;
		    }
		    return card;
		},
		format_type(row) {
		    let card = ''; //1.借记卡 2.贷记卡
		    switch (row.type) {
				case  "RetreatOrderData":
					card = '风控退单';
					break;
				case  "CaseData":
					card = '风控案例';
					break;
		        default:
		            card = '风控调单';
		            break;
		    }
		    return card;
		},
		
    }
}
</script>

<style>
.el-table .cell {
  white-space: pre-wrap !important;   /*这是重点。文本换行*/
}
</style>